import { useState } from 'react';
import { connect } from 'react-redux';
import { styled } from '@classify/react-core-components/styles';

import { translate } from '@openclassrooms/translations';

import { socialLogin } from 'Modules/auth/actions';
import { fetchCsrf } from 'Modules/auth/hooks/useCsrf';

import getLoginErrorMessage from '../../services/getLoginErrorMessage';

import ErrorMessage from '../ErrorMessage';
import { AppleLoginButton, AuthType, FacebookLoginButton, GoogleLoginButton } from '../Button';

import Divider from './Divider';

interface Props {
  onLoginUser: (
    type: string,
    values: unknown,
    targetPath: string | undefined,
    csrfToken: string | undefined,
    isRegister: boolean
  ) => void;
  formMetas?: {
    csrfToken?: string;
    targetPath?: string;
  };
  isRegister?: boolean;
}

const ButtonContainer = styled('div')(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: spacing(2),
}));

export const SocialLogin = ({ onLoginUser, formMetas = {}, isRegister = false }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const createOnSuccessHandler = (type: AuthType) => async (socialProps: any) => {
    const isFacebook = type === 'facebook';
    if (isFacebook && !socialProps.accessToken) return;
    if (isFacebook && !socialProps.email && !socialProps.profileObj) {
      setErrorMessage(translate('auth.errors.no_email_social'));
      return;
    }

    setErrorMessage(null);

    if (!formMetas.csrfToken) {
      const { token: csrfToken, targetPath, error } = await fetchCsrf('/register_ajax');
      if (error) {
        setErrorMessage(getLoginErrorMessage(error));
      }

      onLoginUser(type, socialProps, targetPath, csrfToken, isRegister);
    } else {
      onLoginUser(type, socialProps, formMetas.targetPath, formMetas.csrfToken, isRegister);
    }
  };

  return (
    <>
      <Divider />

      {errorMessage && <ErrorMessage errorMessage={errorMessage} />}

      <ButtonContainer>
        <GoogleLoginButton onSuccess={createOnSuccessHandler('google')} />

        <FacebookLoginButton
          onSuccess={createOnSuccessHandler('facebook')}
          onError={setErrorMessage}
          isRegister={isRegister}
        />

        <AppleLoginButton
          onSuccess={(data: unknown) => createOnSuccessHandler('apple')(data)}
          isRegister={isRegister}
        />
      </ButtonContainer>
    </>
  );
};

// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  // @ts-ignore
  onLoginUser: (type, values, targetPath, csrfToken, isRegister) =>
    dispatch(socialLogin(type, values, targetPath, csrfToken, isRegister)),
});

const enhanced = connect(null, mapDispatchToProps);

// @ts-ignore
export default enhanced(SocialLogin);
